import { ComponentProps } from 'react';
import { Divider as MUIDivider } from '@mui/material';

export const Divider = (props: ComponentProps<typeof MUIDivider>) => {
  return <MUIDivider {...props} />;
};
